import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
//
//
//
//
//

export default {
  name: 'LicenseInfo',
  computed: {
    performanceIdByRoute: function performanceIdByRoute() {
      var performanceId = +this.$route.params.performanceId;
      if (isNaN(performanceId)) {
        performanceId = +this.$route.params.performanceId.match(/\d+/)[0];
      }
      return performanceId;
    }
  },
  mounted: function mounted() {
    try {
      window.seedAction({
        evt: 'view',
        bid: 'b_movie_udsu06t2_mv',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.performanceIdByRoute
        }
      });
    } catch (error) {}
  },
  methods: {
    toPage: function toPage() {
      try {
        window.seedAction({
          evt: 'click',
          bid: 'b_movie_udsu06t2_mc',
          cid: 'c_c21utqjf',
          abtest: 1,
          custom: {
            performance_id: this.performanceIdByRoute
          }
        });
        this.go("/license-info/".concat(this.performanceIdByRoute), {
          _blank: true
        });
      } catch (error) {}
    }
  }
};